import { render, staticRenderFns } from "./chemical.vue?vue&type=template&id=4dd9e6a8&scoped=true&"
import script from "./chemical.vue?vue&type=script&lang=js&"
export * from "./chemical.vue?vue&type=script&lang=js&"
import style0 from "./chemical.vue?vue&type=style&index=0&id=4dd9e6a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9e6a8",
  null
  
)

export default component.exports